import { apiRequest } from './client';
import type { HydrationDetailPayload, IntegrationSummary } from './types';

export async function getHydrationDetail(): Promise<IntegrationSummary<HydrationDetailPayload>> {
  return apiRequest<IntegrationSummary<HydrationDetailPayload>>('/integrations/hydration/detail');
}
